//variables for the gallery and product information on the PDP
var omegaDivTab = document.querySelector(".content-div");
var alphaDivTab = document.querySelector(".image-div");
//end Variables

// description tabbing on PDP
function openCity(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";

  if (window.innerWidth > 991.99) {
    //variables used for the gallery and product information on the PDP
    var omegaHeightTab = omegaDivTab.offsetHeight;
    alphaDivTab.style.height = omegaHeightTab + 100 + "px";
  }
  // end usage
}
